import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { withRouter } from '../withRouter';
import { addToCart } from 'actions/cart';
import styles from './GameStyles.module.scss'
import GameAddonList from '../../constants/GameAddonList';
import basketIcon from '../../images/icons/basketIcon.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import PricingFunctions from '../../common/PricingFunctions';
import kickstarterLogo from 'images/kickstarter-logo.png';
import DotLoader from 'components/Utlility/DotLoader';

class Game extends Component {
    static displayName = Game.name;

    constructor(props) {
        super(props);

        this.state = {
            game: null,
            gameAddons: this.getAddons(),
        };

        this.focus = React.createRef();
    }

    getAddons() {
        if (this.props.isTvApp) {
            return [];
        }
        return GameAddonList.filter((a) => a.forGameId === this.props.game.gameId).map((a) => {
            const owned = a.price === 0 || (this.props.addons && this.props.addons.find(owendAddon => owendAddon.code === a.addonId) ? true : false);
            return { ...a, owned }
        });
    }

    componentDidMount() {
        if (this.props.focus) {
            this.focus.current?.focus();
        }
    }

    tryGoToGame(gameId) {
        this.props.room.room.send("StartGame", { gameId });
    }

    clickAddToCart(game) {
        this.props.addToCart(game);
    }

    ownsGame() {
        return this.props.owned;
    }

    getCardStyling() {
        // Bad name of method, this is specific to card background
        return {
            backgroundImage: `url(${this.props.game.meta.cardBackground})`
        }
    }

    getCardPriceBannerStyling() {
        return {
            background: this.props.game.meta.cardPriceColour
        }
    }

    getButtonStyling(opacity = 1) {
        return {
            background: this.props.game.meta.storeAccentColour
        }
    }

    getBannerStyling() {
        return {
            background: this.props.game.meta.bannerColour ? this.props.game.meta.bannerColour : this.props.game.meta.storeAccentColour
        }
    }

    clickGameCard = (e) => {
        e.preventDefault();
        if (this.props.onClickOverride && !this.props.game?.kickstarter) {
            this.props.onClickOverride(this.props.game)
            return;
        }
        if (this.props.fromLobby) {
            this.props.loadGameMenu(this.props.game);
        } else {
            this.props.navigate(this.props.game.storeSlug)
        }
    }

    getPrice() {
        let countryCode = this.props.pricing.countryCode;
        return PricingFunctions.getGamePricing(countryCode, this.props.game).display;

    }

    goToAddon(g) {
        if (g.owned) this.props.loadGameMenu(this.props.game);
        else this.props.navigate(g.storeSlug);
    }
    getAddonText() {
        const ownedCount = this.state.gameAddons.filter(a => a.owned).length;
        const availableCount = this.state.gameAddons.length - ownedCount;
        let text = "Add-ons: "
        text += ownedCount !== 0 ? `${ownedCount} owned` : "";
        if (ownedCount > 0 && availableCount > 0) text += ", "
        text += availableCount !== 0 ? `${availableCount} available` : "";
        return text;
    }

    renderAddonList() {
        const addons = this.state.gameAddons.map((a) => {
            return <div className={styles.addonCard} key={a.addonId}>
                {/*{a.owned && <FontAwesomeIcon icon={faCircleCheck} target="_blank" />}*/}
                <img className={`${a.owned && styles.owned}`} src={a.meta.tinyCard} onClick={() => this.goToAddon(a)} alt="addon-card" />
            </div>
        });
        if (addons.length > 0) {
            return <>
                <div className={styles.addonList} style={this.getButtonStyling()}>
                    {addons}
                </div>
            </>
        } else {
            return null;
        }
    }

    getAdditionalCardStyles() {
        if (this.props.game?.gameId === "playing_with_fire") {
            return {
                width: '50%',
                objectFit: 'cover',
                imageRendering: 'pixelated',
                position: 'absolute',
                top: '50%',
            }
        } else if (this.props.game?.gameId === "dond") {
            return {
                width: "75%"
            }
        }
    }

    getAdditionalAccent() {
        if (this.props.game?.name === "Playing With Fire") {
            let styles = {
                position: 'absolute',
                left: '27%',
                bottom: '10%',
                height: '40%',
                transform: 'translateX(-50%)',
                imageRendering: 'pixelated'
            }
            return <img src={this.props.game?.meta?.animatedAccent} style={styles} />
        }
    }

    onAddToCart(game) {
        if (this.props.onAddToCartOverride) {
            this.props.onAddToCartOverride(game)
            return;
        }
        this.clickAddToCart(this.props.game)
    }

    openInNewTab(url) {
        window.open(url, '_blank').focus();
    }

    onBuyNow(game) {
        if (this.props.onBuyNow) this.props.onBuyNow(game)
    }

    render() {
        return (
            this.props.game &&
            <div className={`${styles.gameCardWrapper} ${this.props.fromLobby && styles.lobby} ${this.state.gameAddons.length > 0 && styles.hasAddons} ${!this.props.game.enabled && styles.hidden}`}>
                {this.props.fromLobby && this.renderAddonList()}
                <div className={styles.gameCard}>
                    {
                        this.props.gameVotes > 0 &&
                        <div className={styles.votesCounter} style={this.getCardPriceBannerStyling()}><span>{this.props.gameVotes}</span></div>
                    }
                    <div className={`${styles.gameCardBackground} ${this.props.fromLobby && styles.rounded}`} style={this.getCardStyling()}>
                        <img src={this.props.game.meta.cardLogo} style={this.getAdditionalCardStyles()} className={`${styles.gameCardLogo} ${this.props.game.meta.cardLogo2 && styles.hasSecond}`} alt={`${this.props.game.name} logo`}></img>
                        {
                            this.getAdditionalAccent()
                        }
                        {this.props.game.meta.cardLogo2 && <img src={this.props.game.meta.cardLogo2} className={styles.gameCardLogo2} alt={`${this.props.game.name} logo`}></img>}
                        {
                            !this.props.fromLobby && this.props.game?.price &&
                                <div className={styles.priceBanner} style={this.getCardPriceBannerStyling()}><span>{this.getPrice() || <DotLoader size="small" variant="dark" />}</span></div>
                        }
                        <div onClick={this.clickGameCard} className={styles.clickOverlay} tabIndex={this.props.tabIndex} ref={this.focus} />
                        {
                            this.props.game.gameInfo.banner && !this.props.fromLobby &&
                            <div className={styles.banner} style={this.getBannerStyling()}>{this.props.game.gameInfo.banner}</div>
                        }
                        {this.props.fromLobby && this.state.gameAddons.length > 0 && !this.props.hideAddons &&
                            <div className={styles.availableAddons} style={this.getButtonStyling()}>{this.getAddonText()}</div>
                        }
                    </div>
                    {
                        !this.props.fromLobby &&
                        <React.Fragment>
                            <div className={`${styles.cardDescriptionBox} p-3`}>
                                <h4>{this.props.game.name}</h4>
                                <p>{this.props.game.description}</p>
                            </div>
                            {
                                this.props.isTvApp ?
                                    <h4 className={`${styles.addToCartBox} p-3`}>Buy via another device</h4>
                                    :
                                    this.props.game?.kickstarter ?
                                        <div className={styles.buttons}>
                                                    <button onClick={() => { this.openInNewTab("https://www.kickstarter.com/projects/1169339123/deal-or-no-deal-the-party-game-for-your-tv") }} className={`${styles.button} ${styles.addToCart} p-3 ${styles.kickstarter}`}>
                                                <h6>FIND OUT MORE ON</h6>
                                                <img src={kickstarterLogo} className={styles.kickstarterLogo}></img>
                                            </button>
                                        </div>
                                        :
                                        <div className={styles.buttons}>
                                            {this.props.showBuyNow &&
                                                <button onClick={() => { this.onBuyNow(this.props.game) }} className={`${styles.button} ${styles.buyNow} p-3`}>
                                                    <h4>{this.props.buyNowText ?? "Buy Now"}</h4>
                                                </button>
                                            }
                                            {this.props.showAddToCart &&
                                                <button onClick={() => { this.onAddToCart(this.props.game) }} className={`${styles.button} ${styles.addToCart} ${this.props.smallCartButton && styles.miniButton} p-3`}>
                                                    {this.props.smallCartButton ?
                                                        < img src={basketIcon} alt="" width="25" height="29"></img>
                                                        : <h4>{this.props.addToCartText ?? "Add To Cart"}</h4>
                                                    }
                                                </button>
                                            }
                                        </div>
                            }
                        </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
        pricing: state.pricing,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (game) => {
            dispatch(addToCart(game))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Game));
